import {
  CREATE_IN_CAMP_TRAINING,
  CREATE_IN_CAMP_TRAINING_SUCCESS,
  CREATE_IN_CAMP_TRAINING_FAILURE,
  CREATE_IN_CAMP_TRAINING_RESET,

  UPDATE_IN_CAMP_TRAINING,
  UPDATE_IN_CAMP_TRAINING_SUCCESS,
  UPDATE_IN_CAMP_TRAINING_FAILURE,
  UPDATE_IN_CAMP_TRAINING_RESET,
} from "../ActionTypes"


export const createInCampTraining = payload => ({
  type: CREATE_IN_CAMP_TRAINING,
  payload
})

export const createInCampTrainingSuccess = payload => ({
  type: CREATE_IN_CAMP_TRAINING_SUCCESS,
  payload
})

export const createInCampTrainingFailure = payload => ({
  type: CREATE_IN_CAMP_TRAINING_FAILURE,
  payload
})

export const createInCampTrainingReset = payload => ({
  type: CREATE_IN_CAMP_TRAINING_RESET,
  payload
})

export const updateInCampTraining = payload => ({
  type: UPDATE_IN_CAMP_TRAINING,
  payload
})

export const updateInCampTrainingSuccess = payload => ({
  type: UPDATE_IN_CAMP_TRAINING_SUCCESS,
  payload
})

export const updateInCampTrainingFailure = payload => ({
  type: UPDATE_IN_CAMP_TRAINING_FAILURE,
  payload
})

export const updateInCampTrainingReset = payload => ({
  type: UPDATE_IN_CAMP_TRAINING_RESET,
  payload
})